// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e92eacb","692":"4b189144","884":"61868927"}[chunkId] + ".chunk.js";
};